module.exports = __webpack_public_path__ + "static/winston2.abb66261.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/winston2.jpg
// module id = 467
// module chunks = 79737414614040